// Cross-tab "open this record" primitives.
//
//   jumpTo(slug, id)           — navigate to a tab and ask it to open one
//                                record's detail panel.
//   useDetailJump(slug, open)  — the listening end. Checks localStorage on
//                                mount (destination tab newly rendered) and
//                                listens for the live event (destination
//                                already mounted on the same hash).
//
// Used by Reconciliation, Card Statements, the Ledger, and the Items /
// Proposals / POs / Invoices / Receipts tabs.

import { useEffect } from 'react';

var KEY = 'detail-jump';

export function jumpTo(slug, recordId) {
  try { localStorage.setItem(KEY, JSON.stringify({ slug: slug, id: recordId, ts: Date.now() })); }
  catch (_e) { /* ignore */ }
  window.location.hash = '#/' + slug;
  try { window.dispatchEvent(new CustomEvent(KEY, { detail: { slug: slug, id: recordId } })); }
  catch (_e) { /* ignore */ }
}

export function useDetailJump(slug, openDetail) {
  useEffect(function() {
    function consume(hint) {
      if (!hint || hint.slug !== slug || !hint.id) return;
      try { openDetail(hint.id); } catch (_e) { /* swallow */ }
      try { localStorage.removeItem(KEY); } catch (_e) { /* swallow */ }
    }
    try {
      var raw = localStorage.getItem(KEY);
      if (raw) consume(JSON.parse(raw));
    } catch (_e) { /* ignore */ }
    function onJump(e) { consume(e && e.detail); }
    window.addEventListener(KEY, onJump);
    return function() { window.removeEventListener(KEY, onJump); };
  }, [slug, openDetail]);
}
